import styles from "./Dialog.module.css"
import { ReactComponent as CloseIcon } from "../../assets/images/icons/ic-close.svg"
import { DialogStatus } from "../../enums"
import Loader from "../Loader"
import { ReactComponent as ErrorIcon } from "../../assets/images/icons/ic-error.svg"
import Succeeded from "../animated/Succeeded"
import { useTranslation } from "react-i18next"
import { useEffect } from "react"

let openDialogsCount = 0
let initialHtmlOverflow = ""

const lockPageScroll = () => {
    if (typeof document === "undefined") return

    if (openDialogsCount === 0) {
        initialHtmlOverflow = document.documentElement.style.overflow
        // Lock the root scroller only: body has height: 100%, so hiding its
        // overflow would clip the document and clamp the window scroll to zero.
        document.documentElement.style.overflow = "hidden"
    }

    openDialogsCount += 1
}

const unlockPageScroll = () => {
    if (typeof document === "undefined") return

    openDialogsCount = Math.max(0, openDialogsCount - 1)

    if (openDialogsCount === 0) {
        document.documentElement.style.overflow = initialHtmlOverflow
    }
}

const Dialog = ({ appearance, open, title, children, onClose, style, containerStyle, contentStyle, action, noHeader = false, status = null, errorMessage = "", successMessage = "", contentMaxHeight = "100vh", overflow = 'auto' }) => {
    const { t } = useTranslation()

    const handleClose = () => {
        if (onClose && typeof onClose === 'function') {
            onClose()
        }
    }

    useEffect(() => {
        if (!open) return
        lockPageScroll()
        return unlockPageScroll
    }, [open])


    return (
        <>
            {open &&
                <div className={styles.container} style={containerStyle} id="dialogContainer" onClick={(e) => {e.stopPropagation()}}>
                    <div className={`${styles.card} ${appearance === "modern" ? styles.modern : ""}`} style={style} id="dialogCard">
                        <div className={`${noHeader ? `${styles.header} ${styles.noHeaderStyle}` : styles.header}`}>
                            <div className={styles.title}>{title}</div>
                            <button type="button" aria-label="Chiudi" className={styles.closeButton} onClick={handleClose}>
                                <CloseIcon className={styles.closeIcon}></CloseIcon>
                            </button>
                        </div>
                        <div className={styles.content} style={{ maxHeight: contentMaxHeight, overflowY: overflow, ...contentStyle }}>
                            {
                                (status === null || status === DialogStatus.Default) && children
                            }

                            {status === DialogStatus.Success &&
                                <div className={styles.resultContainer}>
                                    <Succeeded width="60%" height="60%" />
                                    {
                                        successMessage &&
                                        <div className={styles.title}>{successMessage}</div>
                                    }
                                </div>
                            }
                            {status === DialogStatus.Error &&
                                <div className={styles.error}>
                                    <ErrorIcon className={styles.icon} style={{ color: "var(--secondary)" }} />
                                    <div className={styles.errorMessage}>{errorMessage || t("dialog.defaultError")}</div>
                                </div>
                            }
                            {
                                status === DialogStatus.Loading &&
                                <div className={styles.resultContainer}> <Loader /> </div>
                            }
                        </div>
                        {action &&
                            <div className={styles.action}>
                                {action}
                            </div>
                        }
                    </div>
                </div>
            }
        </>

    )
}

export default Dialog
